import fetch from '../utils/fetch';

const BaseUrl = process.env.MONO_BASE;

const getUrl = (path) => `${BaseUrl}${path}`;

export default {
  async getTags(query = {}) {
    return fetch(getUrl('/tags'), { query });
  },

  async createTag(tagName) {
    return fetch(getUrl('/tags'), {
      method: 'POST',
      body: { tagName },
    });
  },
};
